module.exports = __webpack_public_path__ + "static/img/platinum.f951348.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tier-icons/platinum.png
// module id = 374
// module chunks = 1